import { isActivityApiError } from '../activity.type';

export const extractActivityApiError = (error: unknown) => {
  if (!isActivityApiError(error)) {
    return 'unknown_error';
  }
  if (error?.params) {
    return error.params;
  }
  return error.message;
};
